import { object, string } from "yup";
import { validateEncode } from "lib/validation/validateEncode";
import { KATAKANA_PATTERN } from "lib/constants";

const contactName = () =>
  string()
    .max(20, "20文字以下にしてください")
    .required("必須項目です")
    .matches(KATAKANA_PATTERN, { message: "全角カタカナで入力してください" })
    .test("encoding", "不正な文字が含まれてます。", async function (value) {
      return validateEncode(this, value);
    });

const phoneNumber = () =>
  string()
    .required("必須項目です")
    .matches(/^\d{10,11}$/, "電話番号は10~11桁の数値で入力してください");

export const pickupContactSchema = object({
  name: contactName(),
  phone_number: phoneNumber(),
});
